/*
 * @FilePath     : /fe-eshotel/src/components/picker/date.js
 * @Author       : LiYang
 * @Date         : 2022-01-27 11:28:05
 * @LastEditTime : 2022-01-28 13:44:38
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */

export const getDate = (date) => new Date(date)
export const getMonthEndDay = (year, month) =>32 - new Date(year, month - 1, 32).getDate()
export const getTime = (length, traverse) => Array.apply([], {length}).map(traverse)
export const addZero = (input) => `00${input}`.slice(-2)

export function getRangeYear(min, max) {
  return getTime(max -  min + 1, (item, index) => {
    return min + index
  })
}

export function getRange(min, max) {
  return getTime(max - min + 1, (item, index) => {
    return addZero(min + index)
  })
}

export const getFullDate = (time) => {
  const date = new Date(time);
  return [
    date.getFullYear(),
    addZero(date.getMonth() + 1),
    addZero(date.getDate()),
    addZero(date.getHours()),
    addZero(date.getMinutes()),
    // addZero(date.getSeconds())
  ]
}


